import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { LegalPage, legalDocFor } from "./ui/LegalPage";
import { AudiencePage } from "./ui/AudiencePage";
import { audienceFor } from "./site";
import { currentLanguage } from "./player/i18n";
import "./styles.css";

// the page's language (index.html says "ca"): fonts, hyphenation and screen readers
document.documentElement.lang = currentLanguage();

// /privacy-policy, /terms-and-conditions, /cookie-policy: the legal pages (old WordPress addresses)
const legal = legalDocFor(location.pathname);
// /schools, /special-needs: Make It for schools and for special educational needs
const audience = audienceFor(location.pathname);

const render = () =>
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      {legal ? <LegalPage doc={legal} /> : audience ? <AudiencePage audience={audience} /> : <App />}
    </StrictMode>,
  );

// dev / e2e: the local Firebase emulators (see emulators.ts)
if (import.meta.env.VITE_EMULATORS === "1") void import("./emulators").then(render);
else render();
